import Instance from '../../../utils/Axios';

// New Actions for the app

const GetTiposFaltasDrop = () => async (dispatch) => {
  await Instance()
    .get(`/tipofaltas/dropdown`)
    .then(({ data }) => {
      dispatch({ type: 'GET_TIPOFALTAS_DROPDOWN', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetTiposFaltasDrop;
